import { UserDto } from '@/app/models/user/user.dto';
import Entity from '../../entity';

export interface ITenantDTO {
  apiKey: string;
  name: string;
  domain: string;
  subdomain: string;
  icon: string;
  logo: string;
  logoDarkmode: string;
  appTheme: string;
  appColor: string;
  stripeCustomerId: string;
  stripeSubscriptionId: string;
  currentUser?: ITenantUser;
  memberCount?: number;
}

export interface ITenantUser extends Entity<string> {
  tenantId: number;
  tenant?: ITenantDTO;
  userId: number;
  user: UserDto;
  role: TenantUserRole;
  active: boolean;
}

export interface ITenantUserDto extends Entity<string> {
  email: string;
  firstName: string;
  lastName: string;
  phone: string;
  tenantId: number;
  tenant: ITenantDTO;
  userId: number;
  user: UserDto;
  role: TenantUserRole;
  joined: TenantUserJoined;
  status: TenantUserStatus;
  accepted: boolean;
}

export enum TenantUserRole {
  Owner,
  Admin,
  Member,
  Guest,
}
export enum TenantUserJoined {
  Creator,
  JoinedByInvitation,
  JoinedByLink,
  JoinedByPublicUrl,
}

export enum TenantUserStatus {
  PendingInvitation,
  PendingAcceptance,
  Active,
  Inactive,
}
